import * as React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Box, CardContent, Dialog, Grid, IconButton } from "@mui/material";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { CountdownCmp } from "../countdown/Countdown";
import { NoticeCountdownCmp } from "../countdown/NoticeCountdown";
import { title } from "process";
import MaterialTextFieldComponent from "../textField/MaterialTextFieldCmp";
import { Formik } from "formik";
import DropdownCmp2 from "../dropdown/DropdownCmp2";
import { useMutation } from "react-query";
import { CreateNewPaymentSettlement } from "../../services/supplierPayment.service";
import { CreateNewPaymentSettlementRequest } from "../../models/supplierPayment.model";
import { ToastContainer, toast } from "react-toastify";
import { useHistory } from "react-router-dom";

const style = {
  position: "absolute" as "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

export default function ModalSettlementType({
  openModel,
  setSendConfirmation,
  setOpenVerifyModal,
  supplierSettlementRequestKeys,
  settlementAmount
}: any) {
  const [open, setOpen] = React.useState<boolean>(openModel);
  const settlementType = [
    {
      id: 1,
      title: "چک",
    },
    // {
    //     id: 2,
    //     title: "آنلاین"
    // },
  ];
  const [settlementTypeOption, setSettlementTypeOption] = React.useState(
    settlementType
  );
  const [selectSettlementType, setSelectSettlementType] = React.useState();
  const [description, setDescription] = React.useState();
  const history = useHistory();
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleSelectedDrop = (e: any) => {
    setSelectSettlementType(e.target.value);
  };
  const handleChangeDescription = (e: any) => {
    setDescription(e.target.value);
  };
  const handleClose = () => {
    setOpen(false);
    setSendConfirmation(false);
    setOpenVerifyModal(false);
  };
  React.useEffect(() => {
    setOpen(openModel);
  }, [openModel]);

  function handleOnCompletedClick() {
    setSendConfirmation(true);
    setOpen(false);
    setOpenVerifyModal(false);
  }
  function handleCreateNewPayment() {
    let createNewPaymentSettlement = new CreateNewPaymentSettlementRequest();
    createNewPaymentSettlement.settlementType = selectSettlementType;
    createNewPaymentSettlement.supplierSettlementRequestKeys = supplierSettlementRequestKeys;
    createNewPaymentSettlement.description = description;
    createNewPaymentSettlementMutation.mutate(createNewPaymentSettlement);
    setSendConfirmation(true);
    setOpen(false);
    setOpenVerifyModal(false);
  }

  const createNewPaymentSettlementMutation = useMutation(
    CreateNewPaymentSettlement,
    {
      onSuccess: (result: string) => {
        if (result) {
          toast.success(" عملیات با موفقیت انجام شد.");
          window.sessionStorage.setItem("playlistData", "");
          // toast.success(" عملیات با موفقیت انجام شد.", { progress: undefined, autoClose: false, closeOnClick: true, closeButton: true });
          history.push("SettlementWithReceiver");
        }
      },
    }
  );

  const backClick = () => {
    handleClose();
  }

  let initialValues = new CreateNewPaymentSettlementRequest();

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Formik
          initialValues={initialValues}
          onSubmit={(values) => { }}
          validateOnMount={true}
        // validationSchema={userCreditAmountSchema}
        >
          {({
            handleSubmit,
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
          }) => (
            <form onSubmit={handleSubmit}>
              <>
                <Grid>
                  <Box
                    sx={style}
                    style={{
                      borderRadius: "6px",
                      padding: "2px 40px 40px 40px",
                    }}
                    className="ModalCmp  "
                  >
                    <Grid
                      item
                      xs={12}
                      className="classCenter"
                      style={{ paddingTop: "5vh" }}
                    >
                      <span className="textFont16 colorDefaultFont">
                        آیا از
                        <span className="SuccessDefaultFont"> تسویه </span>با
                        مبلغ
                        <span className="SuccessDefaultFont"> {settlementAmount!.toLocaleString()} ریال </span>
                        اطمینان دارید؟
                      </span>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      // className="classCenter"
                      style={{ paddingTop: "5vh" }}
                    >
                      <DropdownCmp2
                        onBlur={handleBlur}
                        style={{ paddingRight: "0 !important" }}
                        onChange={handleSelectedDrop}
                        value={selectSettlementType}
                        label={"نوع تسویه*"}
                        options={settlementTypeOption}
                        name="settlementType"
                        id="settlementType"
                      />
                    </Grid>
                    <Grid style={{ marginTop: "35px" }}>
                      <MaterialTextFieldComponent
                        className={"heightTextField"}
                        label={"توضیحات"}
                        required={false}
                        rows={2}
                        value={description}
                        onChange={handleChangeDescription}
                        name="description"
                        id="outlined-textarea"
                        multiline
                        sx={{
                          "& .MuiOutlinedInput-root > .MuiInputBase-input ": {
                            fontSize: 13,
                            lineHeight: "2vh !important",
                            height: "6vh !important",
                          },

                          "& .MuiInputBase-root": {
                            height: "14vh !important",
                          },
                        }}
                        placeHolder={"توضیحات"}
                      />
                    </Grid>
                    <Grid
                      container
                      xs={12}
                      style={{ paddingTop: "5vh", paddingBottom: "3vh" }}
                    >
                      <Grid item xs={6} style={{ textAlign: "end" }}>
                        <Button
                          type="submit"
                          disabled={selectSettlementType ? false : true}
                          className={
                            selectSettlementType
                              ? "btnForm SuccessDefault "
                              : "btnForm disabledBtn  "
                          }
                          onClick={handleCreateNewPayment}
                          // className={"btnForm SuccessDefault "}
                          style={{ width: "170px", marginLeft: "1vh" }}
                        >
                          تایید و ادامه
                        </Button>
                      </Grid>
                      <Grid item xs={6} style={{ paddingRight: "2vh" }}>
                        <Button
                          className="btnForm ComingBack"
                          style={{
                            width: "170px",
                            marginLeft: "1vh",
                            textAlign: "left",
                          }}
                          onClick={backClick}
                        >
                          بازگشت
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </>
            </form>
          )}
        </Formik>
      </Modal>
    </div>
  );
}
